<ds-loading *ngIf="(loading | async) || (isAuthenticated | async)" class="m-5"></ds-loading>
<div *ngIf="(loading | async) !== true && (isAuthenticated | async) !== true" class="px-4 py-3 mx-auto login-container">
  <ng-container *ngFor="let authMethod of (authMethods | async); let last = last">
    <ds-log-in-container [authMethod]="authMethod" [isStandalonePage]="isStandalonePage"></ds-log-in-container>
    <div *ngIf="!last" class="dropdown-divider my-2"></div>
  </ng-container>
</div>
